import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FileUploader from 'components/FileUploader';
import { useFormikContext } from 'formik';
import React, { useState, useCallback } from 'react';

import type { INewAccount } from 'v2/interfaces/financial';

interface IProps {
  mediaPreview: any;
  setMediaPreview: (name: string, preview: any) => void;
}

const BankReceipt = ({ mediaPreview, setMediaPreview }: IProps) => {
  const { values, setSubmitting, setFieldValue } = useFormikContext<INewAccount>();
  const pathName = window.location.pathname;
  const isRefundAccount = pathName.includes('bank-account-refund');
  const [imgError, setImgError] = useState('');

  const handleUploadEvents = useCallback(
    (event: string, message?: string) => {
      if (event === 'uploading') {
        setSubmitting(true);
        return;
      }

      if (event === 'error') {
        setImgError(message);
      }
    },
    [setSubmitting]
  );

  const handleImageChange = useCallback(
    (name: string, id: number, preview: any) => {
      setMediaPreview(name, preview);

      setFieldValue('imgsIds', { ...values.imgsIds, [name]: id });
      setSubmitting(false);
    },
    [setFieldValue, setMediaPreview, setSubmitting, values.imgsIds]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} sm={12}>
        <Typography variant='subtitle2'>
          Envie-nos um comprovante bancário válido e legível que comprove todos os dados bancários informados no formulário (passo 1).
        </Typography>
      </Grid>

      <Grid item xs={12} md={12} sm={12}>
        <FileUploader
          onChange={handleImageChange}
          fileName='imgBankReceipt'
          defaultPreview={mediaPreview['imgBankReceipt']}
          type='image'
          uploadType='mpg_docs'
          label='Comprovante bancário'
          onEvent={handleUploadEvents}
          isRefundAccount={isRefundAccount}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='subtitle2'>
          Envie arquivos nos formatos: JPG, PNG ou PDF. De no máximo 2mb. <br />
        </Typography>
      </Grid>

      {imgError ? (
        <Grid item xs={12}>
          <div className='m16'></div>
          <div className='bank__error'>{imgError}</div>
          <div className='m16'></div>
        </Grid>
      ) : (
        <div className='m16'></div>
      )}
    </Grid>
  );
};

export default BankReceipt;
